import React from "react"
import { ui } from "../styles/uiSystem"

export default function PillTabs({
  items = [],
  value,
  onChange,
  wrap = true,
  compact = false
}) {
  return (
    <div
      style={{
        display: "flex",
        gap: compact ? 6 : 8,
        flexWrap: wrap ? "wrap" : "nowrap",
        overflow: "visible",
        minWidth: 0
      }}
    >
      {items.map((item) => {
        const active = item.value === value
        const baseStyle = active ? ui.segmentedTabActive : ui.segmentedTab

        return (
          <button
            key={item.value}
            onClick={() => {
              if (item.disabled) return
              if (typeof item.onClick === "function") {
                item.onClick(item)
                return
              }
              onChange?.(item.value, item)
            }}
            disabled={item.disabled}
            style={{
              ...baseStyle,
              minHeight: compact ? 32 : baseStyle.minHeight,
              padding: compact ? "0 11px" : baseStyle.padding,
              fontSize: compact ? 11.5 : baseStyle.fontSize,
              flex: "0 0 auto",
              maxWidth: "100%",
              opacity: item.disabled ? 0.7 : 1,
              cursor: item.disabled ? "not-allowed" : "pointer"
            }}
          >
            {item.label}
          </button>
        )
      })}
    </div>
  )
}
